import styled from 'styled-components'

export const MarginWrapper = styled.div<{ x?: number }>`
  width: 100%;
  margin-top: ${({ x }) => (x ?? 1) * 20}px;
  text-align: center;
`
